
import '../App.css';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
function App() {
  return (
    <div className="App">

    <Header/> 
    <Contact/>
    <Footer/>
    </div>
  );
}

export default App;
